import * as React from 'react';

import { sizes } from './constants';
import * as styles from './index.style';

interface Props {
  src: string | null;
  size: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  appearance: 'circle' | 'square';
  fallback?: React.ReactNode;
}

interface State {
  imageLoadFailed: boolean;
}

// Inspired from Atlaskit's packages/navigation/atlassian-switcher/src/primitives/avatar.tsx
// Designed with love in Sydney.
export default class IconWithFallback extends React.Component<Props, State> {
  state = {
    imageLoadFailed: false,
  };

  onError = () => {
    this.setState({ imageLoadFailed: true });
  };

  render() {
    const { src, size, appearance, fallback } = this.props;
    const sizePx = sizes[size];
    return (
      <styles.Container size={sizePx}>
        {fallback}
        {src && !this.state.imageLoadFailed && (
          <styles.Image
            appearance={appearance}
            size={sizePx}
            src={src}
            onError={this.onError}
            alt=""
            role="presentation"
          />
        )}
      </styles.Container>
    );
  }
}
